import { useViewportTier } from '@admin-panel/hooks/ui/useViewportTier';

/** Phone tier (below 768 px): the mobile shell, bottom sheets and phone action bars. */
export function useMobileLayout(): boolean {
  return useViewportTier() === 'phone';
}
